import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EventsService, OrganizationService } from '@services';
import { LoansHttpService, OrganizationEventDto } from 'app/api';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { OrganizationEventExtended } from '../../../helpers/events.helper';
import { LoanFilterLoan } from '../table-loan-filter/table-loan-filter.component';

@Component({
    selector: 'app-events-list-ls',
    templateUrl: './events-list-ls.component.html',
    standalone: false
})
export class EventsListLsComponent implements OnInit, OnChanges {
	@Input() events: OrganizationEventDto[];
	@Input() loading: boolean;
	@Input() canLoadMore: boolean;
	@Input() showLoanFilter = false;
	@Output() load = new EventEmitter<void>();
	@Output() loanFilterChange = new EventEmitter<string>();

	allLoans$: Observable<LoanFilterLoan[]>;
	lastAvailableLoans: LoanFilterLoan[] = [];

	mappedEvents: OrganizationEventExtended[] = [];

	constructor(
		private loansService: LoansHttpService,
		private eventsService: EventsService,
		private organizationService: OrganizationService,
		private translateService: TranslateService
	) {}

	ngOnInit(): void {
		const organizationId = this.organizationService.getOrganizationId();
		const creditId = this.organizationService.getCreditId();

		this.allLoans$ = this.loansService.getAllLoans(organizationId, creditId).pipe(
			map(loans => {
				return loans.map(loan => ({
					id: loan.loanId,
					name: loan.displayId,
				}));
			}),
			shareReplay(1)
		);

		// Combine loans (async) and events (static) for processing
		this.allLoans$?.subscribe(loans => {
			this.updateMappedEvents(loans, this.events);
		});

		this.translateService.onLangChange.subscribe(_ => {
			this.updateMappedEvents(this.lastAvailableLoans, this.events);
		});
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.events) {
			this.updateMappedEvents(this.lastAvailableLoans, this.events);
		}
	}

	private updateMappedEvents(loans: LoanFilterLoan[] = [], events: OrganizationEventDto[] = []): void {
		this.lastAvailableLoans = loans; // Cache the latest loans
		this.mappedEvents = this.eventsService.formatLSEventsForDisplay(events, loans);
	}

	public async handleLoanFilterChange(selectedLoanId: string) {
		this.loanFilterChange.emit(selectedLoanId);
	}
}
